import React from 'react';
import Modal from '../../../Components/Modal';
import Form, { Actions, Checkboxes, EventTriggers, Conditional, Switch, ULID, WorkingHours } from '../../../Components/Form';
import { eventTriggers } from '../../../Data/Misc';
import Button from '../../../Components/Button/Button';
import { useDialogues } from '../../../Components/Dialogues';

const Fill = ({isOpen, setIsOpen, calendar, week, generateWeek, clearAppointments, refresh}) => {
    const {confirm, isDialogueOpen} = useDialogues();

    const settings = {
        include: [
            calendar.generateOptions.includeDue ? 'includeDue' : null,
            calendar.generateOptions.includeOverdue ? 'includeOverdue' : null,
            calendar.generateOptions.includeScheduled ? 'includeScheduled' : null,
        ].filter(a => !!a),
        availability: calendar.availability,
        spreadJobs: calendar.generateOptions.objective === 'SpreadJobs',
    };

    const handleSubmit = async (data) => {
        const marshalled = {
            includeOverdueJobs: data.include.includes('includeDue'),
            includeDueJobs: data.include.includes('includeOverdue'),
            includeScheduledJobs: data.include.includes('includeScheduled'),
            autoSchedule: data.autoSchedule ? true : false,
            availability: data.availability,
            week: week,
            objective: data.spreadJobs ? 'SpreadJobs' : 'PackJobs',
            optimisationToken: data.optimisationToken,
        };

        return generateWeek(marshalled);
    }

    return <Modal title="Plan your week" isOpen={isOpen} setIsOpen={setIsOpen} dismissible={!isDialogueOpen}>
        <Form data={settings} onSubmit={handleSubmit} afterSubmit={refresh} closeModalOnSubmit>
            <ULID name="optimisationToken" />
            <Checkboxes name="include" label="Jobs to include" options={[
                    {value: 'includeDue', label: 'Jobs due this week'},
                    {value: 'includeOverdue', label: 'Jobs overdue from previous weeks'},
                    {value: 'includeScheduled', label: 'Scheduled jobs'},
                ]}
                help={v => v.includes('includeScheduled') ? 'Jobs which are already scheduled may be moved.' : 'We\'ll try to work around jobs which are already scheduled.'}
            />
            <Switch name="spreadJobs"
                label="Spread jobs"
                innerLabel="Spread jobs across days / workers"
                help={(val) => val ?
                        <>Jobs will be spread out across the working hours.<br />Nearby jobs will still be grouped together.</> :
                        'Jobs will be packed into the fewest days/workers possible.'
                    }
            />
            <WorkingHours name="availability" label="Working hours" />
            <Switch name="confirm"
                label="Confirm scheduled jobs"
                help={(val) => val ?
                        'Schedule jobs immediately. Customers may be notified' :
                        'You\'ll need to confirm before jobs are scheduled.'
                    }
            />
            <Conditional condition={d => d.confirm}>
                <EventTriggers triggers={[eventTriggers.SEND_NOTIFICATIONS]} />
            </Conditional>
            <Actions
                left={<Button theme="secondary" label="Clear" onClick={() => confirm(
                    {
                        theme: 'danger',
                        title: 'Clear week',
                        message: 'Are you sure you want to clear all your scheduled jobs and tentative appointments for the week? This cannot be undone.',
                        confirmLabel: 'Clear'
                    },
                    () => clearAppointments()
                )} />}
                submit={{label: 'Plan week'}}
                cancel
            />
        </Form>
    </Modal>
}

export default Fill;
